import { types } from '../Reducers/ElemSeleccionadoReducer.js';

export const seleccionarElemento = (id) => ({
  type: types.SELECCIONAR_ELEM,
  id:id,
});
